import React from 'react'
import '../../CSS/global.css'

const ReusableTextBox = (props) => {
  return (
    <input type={props.type} placeholder={props.placeholder} className={props.className} onKeyPress={props.onKeyPress} name={props.name} value={props.value} onChange={props.onChange} id={props.id} role={props.role} list={props.list} placeholder={props.placeholder} onSelect={props.onSelect} onFocus={props.onFocus} onBlur={props.onBlur} maxlength={props.maxlength} pattern={props.pattern} accept={props.accept} ></input>
  )
}

export default ReusableTextBox;